// Central route-path builders. Add new helpers here instead of hand-assembling
// route strings at call sites.

export const adminUserDetailPath = (userId: number | string): string =>
  `/admin/users/${userId}`;
